import React from 'react';
import ContactUs from '../components/ContactUs';

// Features Page: Detailed features
const ContactUsPage = () => {
  return (
    <>
      <ContactUs />
    </>
  );
};

export default ContactUsPage;